module.exports = __webpack_public_path__ + "static/media/UA_logo.b5d90fb2.png";